import React from 'react';
import PropTypes from 'prop-types';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';
import SMConst from 'lib/SMConst';
import SMUserResource from 'resources/SMUserResource';
import SMUFavoriteListCreateView from './SMUFavoriteListCreateView';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import SMRenderHelper from 'components/helpers/SMRenderHelper';

class SMUFavoriteListView extends SMDashboardBaseView {

  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      listItems: [],
      display: this.props.display,
      isFavoriteListCreateViewOpen: false,
    };
  }

  updateState(state) {
    this.setState(state);
  }
  
  componentDidMount() {
    SMRenderHelper.addObserverForBaloon();
    this.applyResponsive();
    this.requestResource();
  }
  
  requestResource(isAppend, callback){
    if (!isAppend) this.setState({display: SMConst.Display.Loading});
    if (!isAppend) $(this.refs.mainCol).startLoading({modalOpacity:0});
    SMUserResource.getFavoriteLists(this.props.user.username, (responses, error, xhr)=>{
      $(this.refs.mainCol).stopLoading();
      this.setState({display: SMConst.Display.Visible});
      if(error || !responses) return;
      let state = {
        listItems: responses,
      };
      this.setState(state);
    });
  }

  showFavoriteListCreateForm(e){
    if (e) e.preventDefault();
    this.setState({
      isFavoriteListCreateViewOpen: true
    });
  }

  favoriteListCreateViewDidClose() {
    this.setState({
      isFavoriteListCreateViewOpen: false,
    });
  }

  renderFavoriteListIndex() {
    return(
      <div className="row">
        {(()=>{
          let rows = [];
          for (let rowIndex = 0; rowIndex < this.state.listItems.length; rowIndex++) {
            const favoriteList = this.state.listItems[rowIndex];
            let favoriteListImageUrl = "";
            if (favoriteList.thumbnail == 0){
              favoriteListImageUrl = this.props.noFavoriteListImage;
            } else {
              favoriteListImageUrl = SMFormatHelper.favoriteListImageURL(favoriteList, {width: 490, height: 490});
            }
            if (!favoriteList) continue;
            rows.push(
              <div key={favoriteList.id} className="col-md-4">
                <a href={Routes.dashboard_favorite_list_path(favoriteList.id)}>
                  <div className="dashboad-favorite__list-select-box">
                    <div className="dashboad-favorite__list-select-box-img">
                      <img src={favoriteListImageUrl} className="dashboad-favorite__list-select-box-img-space" alt={favoriteList.name}></img>
                    </div>
                    <div className="dashboad-favorite__list-select-box-text">
                      <h3 className="dashboad-favorite__list-select-box-text-title">{favoriteList.name}</h3>
                      <p className="dashboad-favorite__list-select-box-text-count">全{favoriteList.total_favorites}件</p>
                    </div>
                  </div>
                </a>
              </div>
            );
          }
          return rows;
        })()}
      </div>
    );
  }

  render() {
    return (
      <div className="dashboard-favorite__list container">
        <form>
          <div ref="mainCol" className="dashboard-maincol">
            <h2 className="dashboard-title dashboard-favorite__list-title mb20">お気に入りリスト</h2>
            <p><a href="#" onClick={this.showFavoriteListCreateForm.bind(this)} className="button-blue dashboard-favorite__list-add"><i className="fa fa-plus mr5"></i>新規リスト作成</a></p>
            <div className="dashboard-favorite__list-select">
              <CSSTransitionGroup transitionName="js-list-fade-animation" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
              {this.renderFavoriteListIndex()}
              </CSSTransitionGroup>
            </div>
          </div>
        </form>
        <SMUFavoriteListCreateView
          delegate={this}
          user={this.props.user}
          listItems={this.state.listItems}
          isOpen={this.state.isFavoriteListCreateViewOpen}
          updateState={this.updateState.bind(this)} />
      </div>
    );
  }
}
SMUFavoriteListView.defaultProps = {
  display: SMConst.Display.Visible
};
SMUFavoriteListView.propTypes = {
  user: PropTypes.object.isRequired
};
export default SMUFavoriteListView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/SMUFavoriteListView.jsx